import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Reserva, ReservaPagamento } from 'src/app/model';
import { ReservaService } from 'src/app/services';

@Component({selector: 'app-slip',
  templateUrl: './slip.component.html',
  styleUrls: ['./slip.component.scss'], standalone: false})
export class SlipComponent implements OnInit{
  Orcamento: any = new Reserva();
  mensagensErroReserva: string[];

  @Input()
  Id : any;

  pagamentosAprovados: ReservaPagamento[] = [];

  distinct = (value, index, self) => {
    return self.indexOf(value) === index;
  }

  constructor(
    private modalService: NgbModal,
    private reservaService: ReservaService,) { }

  ngOnInit() {
    if (this.Id !== undefined) {
      setTimeout(() => { this.carregarObjeto(this.Id); }, 500);
    }
  }

  carregarObjeto(id) {
    this.reservaService.GetSlip(id).subscribe(
      dados => {
        this.Orcamento = dados;
        this.pagamentosAprovados = this.Orcamento.Pagamentos.filter(x => x.Status == 2 || x.Status == 4).sort((a, b) => b.Id - a.Id);

        this.Orcamento.Servicos = this.Orcamento.Servicos.map(x => {
          if (this.isJson(x.ExtraIntegracao)) {
            x.ExtraIntegracao2 = JSON.parse(x.ExtraIntegracao);
          }
          return x;
        });

      },
      erro => {
        console.log("Erro ao buscar o objeto da reserva");
        console.log(erro);
        this.mensagensErroReserva = this.errorHandler(erro);
      }
    )
  }

  fecharModal() {
    this.modalService.dismissAll();
  }

  isJson(str) {
      try {
          JSON.parse(str);
      } catch (e) {
          return false;
      }
      return true;
  }

  public errorHandler(erro): string[] {
    let mensagem = [];
    switch (erro.status) {
      case 0: mensagem.push('o servidor não respondeu, tente novamente mais tarde!'); break;
      case 400:

        if (erro.error && erro.error.mensagem)
          mensagem.push(erro.error.mensagem);
        else
          mensagem.push("Houve algum erro na execução, tente novamente!");

        break;
      case 401: mensagem.push('você não tem autorização para executar esta ação!'); break;
      case 404: mensagem.push(erro.error.mensagem); break;
      case 406: mensagem.push(erro.error.mensagem); break;
      // case 500: mensagem.push('Houve um erro interno no servidor! tente novamente, caso o erro persista, entre em contato com o suporte' ); break;
      case 500: mensagem.push(erro.error.ExceptionMessage); break;
      default: mensagem.push(erro.statusText);
    }
    if (erro.error != null && erro.error.mensagens != null) {
      mensagem = [...mensagem, ...erro.error.mensagens];
    }
    return mensagem;
  }

  noites(dataInicio, dataFim) {
    dataInicio = moment(dataInicio).startOf('day');
    dataFim = moment(dataFim).startOf('day');

    return dataFim.diff(dataInicio, 'days');
  }

  printSlip(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    let originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
    window.location.reload();
  }
}
